import React, { Component } from "react";
import { connect } from "react-redux";

import { forceLogout } from "../../../redux/actions/users";
import { getAllClubs } from "../../../redux/actions/clubs";

import { withRouter } from "react-router-dom";

class Clubs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: [],
      err: {},
    };

    // this.onLogout = this.onLogout.bind(this);
    // this.toggleMenu = this.toggleMenu.bind(this);
  }

  // onLogout(params) {
  //   console.log("onLogout");
  //   if (this.props.forceLogout().status === 200) {
  //     this.props.history.push("/");
  //   }
  // }

  // toggleMenu(params) {}

  componentDidMount() {
    console.log("header mounted");
    this.props
      .getAllClubs()
      .then((res) => {
        console.log(res.data);
        this.setState({
          data: res.data,
          loaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    if (!this.state.loaded) {
      return <div>Plase wait...</div>;
    }

    return (
      <div className="panel home-panel">
        <div className="flex justify-between items-center p-3 bg-blue-900 text-white rounded-md mb-2">
          <span className="text-lg font-semibold">Clubs</span>
          <div
            className="bg-blue-700 cursor-pointer p-2 text-sm rounded-md select-none"
            onClick={() => {
              console.log("add news!");
            }}
          >
            Add Club
          </div>
        </div>
        <div className="flex-row w-full flex-wrap grid-cols-4 grid gap-4 mb-6">
          {this.state.data?.map((item) => {
            return (
              <div
                key={item.id}
                className="flex flex-col align-middle items-center bg-gray-50 p-3 rounded-md shadow relative"
              >
                <div
                  className="rounded-full w-16 h-16"
                  style={{ backgroundImage: "url(" + item.imageurl + ")", backgroundSize: "cover" }}
                ></div>
                <span className="font-bold">{item.name}</span>
                <div className="flex flex-row gap-2">
                  <span>
                    {parseInt(item.member_count) > 1
                      ? item.member_count + " members"
                      : item.member_count + " member"}
                  </span>
                  <span>{item.type.name}</span>
                </div>
                <span className="text-sm">{item.description}</span>
                <div className="text-sm p-2 bg-blue-800 text-white rounded cursor-pointer hover:bg-blue-900 absolute top-2 right-2">
                  Edit
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getAllClubs: (data) => dispatch(getAllClubs(data)),
    forceLogout: (data) => dispatch(forceLogout(data)),
  };
}

const mapStateToProps = (state) => ({
  ...state,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Clubs));
